import moment from 'moment';

export default {
  progressByMonth: calculationModel => ({
    columns: [
      {
        accessorKey: 'month',
        // header: __('report_table_header_task_name'),
        header: __('month').charAt(0).toUpperCase() + __('month').slice(1),
        enableSorting: false,
        align: 'left',
        size: 'auto',
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'baseline_progress',
        // header: __('report_table_header_budget'),
        header: __('report_progress_type_baseline_progress'),
        enableSorting: false,
        enableHiding: true,
        headerIconTooltip: {
          content: __('report_table_baseline_progress_tooltip'),
          iconName: 'info',
          iconColor: '#808080',
        },
        align: 'right',
        size: 160,
        cell: info => {
          const value = info.getValue();

          return `${value}%`;
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'progress',
        // header: __('report_table_header_budget'),
        header: __('report_progress_type_planned_progress'),
        enableSorting: false,
        enableHiding: true,
        headerIconTooltip: {
          content: __('report_table_progress_tooltip'),
          iconName: 'info',
          iconColor: '#808080',
        },
        align: 'right',
        size: 160,
        cell: info => {
          const value = info.getValue();

          return `${value}%`;
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'actual_progress',
        // header: __('report_table_header_actual_cost'),
        header: __('report_progress_type_actual_progress'),
        enableSorting: false,
        enableHiding: true,
        headerIconTooltip: {
          content: __('report_table_actual_progress_tooltip'),
          iconName: 'info',
          iconColor: '#808080',
        },
        align: 'right',
        size: 160,
        cell: info => {
          const value = info.getValue();

          return `${value}%`;
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'variance',
        // header: __('report_table_header_variance'),
        header: __('report_page_variance'),
        headerIconTooltip: {
          content: __(`report_table_s_curves_progress_variance_tooltip_${calculationModel}`),
          iconName: 'info',
          iconColor: '#808080',
        },
        enableSorting: false,
        align: 'right',
        size: 176,
        cell: info => {
          const value = info.getValue();

          return `${value}%`;
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
    ],
    state: {
      columnPinning: {
        left: ['month'],
        right: ['variance'],
      },
      columnOrder: [
        'month',
        'baseline_progress',
        'progress',
        'actual_progress',
        'variance',
      ],
      columnVisibility: {
        month: true,
        baseline_progress: true,
        progress: true,
        actual_progress: true,
        variance: true,
      },
    },
  }),

  portfolio: {
    columns: [
      {
        accessorKey: 'project',
        header: __('gantt_grid_project_name'),
        enableSorting: true,
        enableResizing: true,
        align: 'left',
        size: 'auto',
        cell: info => info.row.original.project.name,
        accessorFn: row => row.project.id,
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
        tooltipContent: row => row.original.project.name,
      },
      {
        accessorKey: 'status',
        header: __('gantt_grid_status'),
        template: 'status',
        size: 132,
        minSize: 64,
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
        accessorFn: row => row.status.label,
      },
      {
        accessorKey: 'progress',
        header: __('gantt_grid_progress'),
        template: 'progress',
        enableSorting: true,
        size: 142,
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId).percentage;
          const bValue = rowB.getValue(columnId).percentage;

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
        cell: info => info.row.original.progress.percentage,
        tooltipContent: row => {
          const {
            countOfPerSchedule,
            countOfSlightlyOverdue,
            countOfOverdue,
          } = row.original.progress;

          return `
                <div>${__('project_countOfPerSchedule', { count: countOfPerSchedule })}</div>
                <div>${__('project_countOfSlightlyOverdue', { count: countOfSlightlyOverdue })}</div>
                <div>${__('project_countOfOverdue', { count: countOfOverdue })}</div>
              `;
        },
      },
      {
        accessorKey: 'start_date',
        header: __('gantt_grid_start_date'),
        size: 132,
        cell: info => info.row.original.start_date,
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = moment(rowA.getValue(columnId), user.dateFormat);
          const bValue = moment(rowB.getValue(columnId), user.dateFormat);

          return aValue.diff(bValue, 'days') === 0 ? 0 : aValue.diff(bValue, 'days') > 0 ? 1 : -1;
        },
      },
      {
        accessorKey: 'end_date',
        header: __('gantt_grid_end_date'),
        size: 132,
        cell: info => info.row.original.end_date,
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = moment(rowA.getValue(columnId), user.dateFormat);
          const bValue = moment(rowB.getValue(columnId), user.dateFormat);

          return aValue.diff(bValue, 'days') === 0 ? 0 : aValue.diff(bValue, 'days') > 0 ? 1 : -1;
        },
      },
      {
        accessorKey: 'creator',
        header: __('project_owner'),
        enableGrouping: true,
        enableSorting: true,
        align: 'left',
        template: 'resource',
        size: 148,
        cell: info => info.row.original.creator,
        accessorFn: row => row.creator?.name ?? 0,
        sortingFn: (rowA, rowB) => {
          const aValue = rowA.original.creator?.name;
          const bValue = rowB.original.creator?.name;

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
        tooltipContent: row => {
          const creator = row.original.creator;

          return creator.name ? `<div style="display: flex; align-items: center; gap: 4px;">
                ${creator.photo ? `<div style="
                  background-image: url(${creator.photo});
                  width: 20px;
                  height: 20px;
                  border-radius: 50%;
                  background-size: 100%;
                  flex-shrink: 0;
                  padding: 1.667px 2.333px 2.333px 1.667px;
                  "></div>` : ''}
                <div>${creator.name}</div>
                </div>` : '';
        },
      },
      // {
      //   id: 'creator',
      //   header: __('project_owner'),
      //   template: 'resource',
      //   accessorFn: row => row.creator.name,
      //   tooltipContent: row => {
      //     const creator = row.original.creator;

      //     return creator.name ? `<div style="display: flex; align-items: center; gap: 4px;">
      //           ${creator.photo ? `<div style="
      //             background-image: url(${creator.photo});
      //             width: 20px;
      //             height: 20px;
      //             border-radius: 50%;
      //             background-size: 100%;
      //             flex-shrink: 0;
      //             padding: 1.667px 2.333px 2.333px 1.667px;
      //             "></div>` : ''}
      //           <div>${creator.name}</div>
      //           </div>` : '';
      //   },
      // },
    ],
    state: {
      columnPinning: {
        left: ['project'],
        right: ['creator'],
      },
      columnOrder: [
        'project',
        'status',
        'progress',
        'start_date',
        'end_date',
        'creator',
      ],
      columnVisibility: {
        project: true,
        status: true,
        progress: true,
        start_date: true,
        end_date: true,
        creator: true,
      },
      sorting: [{
        id: 'start_date',
        desc: false,
      }],
    },
  },
};
